import { businessEmailCheck } from '~/common/util/businessEmail';
const lengthCheck = (value: string) => {
  if (value === null || value === undefined) {
    return 'Value is required.';
  }
  if (value.length > 128) {
    return 'Value is too long.';
  }
  if (value.length === 0) {
    return 'Value cannot be empty.';
  }
  return false;
};

export const validateString = (value: string) => {
  const trimmed = value ? value.trim() : value;
  let error = lengthCheck(trimmed);
  if (error) return error;
  if (trimmed.includes('@')) {
    return "String should not contain '@'.";
  }
  return false;
};

export const validateFullName = (value: string) => {
  const trimmed = value ? value.trim() : value;
  let error = lengthCheck(trimmed);
  if (error) return error;
  if (trimmed.includes('@')) {
    return "Full name should not contain '@'.";
  }
  const regex = /^[^\s]+(\s[^\s]+)+$/;
  if (!regex.test(trimmed)) {
    return 'Full name must contain at least two words.';
  }
  return false;
};

export const validateEmail = (value: string) => {
  let error = lengthCheck(value);
  if (error) return error;
  const emailRegex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
  if (!emailRegex.test(value)) {
    return 'Invalid email format.';
  }
  return false;
};

export const validatePhone = (value: string) => {
  let error = lengthCheck(value);
  if (error) return error;
  if (!/^[0-9-()+ ]*$/.test(value)) {
    return 'Phone number invalid character';
  }
  return false;
};

export const validateSelect = (value: string | number) => {
  if (value === undefined || value === null) {
    return 'A selection is required.';
  }
  if (value.toString().length === 0) {
    return 'Selection cannot be empty.';
  }
  return false;
};

export const validateRadio = (value: string) => {
  if (value === undefined || value === null) {
    return 'A selection is required.';
  }
  if (value.toString().length === 0) {
    return 'Selection cannot be empty.';
  }
  return false;
};

export const validateZip = (value: string) => {
  const trimmed = value ? value.trim() : value;
  let error = lengthCheck(trimmed);
  if (error) return error;
  if (trimmed.length < 1 || trimmed.length > 20) {
    return 'Zip length is incorrect';
  }
  if (!/^[a-zA-Z0-9\-\ ]+$/.test(trimmed)) {
    return 'Invalid character';
  }
  return false;
};
